(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardBusinessPlanningController', Controller);

    Controller.$inject = ['$scope', 'grcGovernanceProcessService'];

    function Controller($scope, grcGovernanceProcessService) {
        grcGovernanceProcessService.getActiveInitiativeUpdateStatus().then(function(governanceProcess) {
            $scope.governanceProcessId = governanceProcess.GovernanceProcessID;
        });
    }
})();